export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 pt-16">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              每日更新 · 热门连载中
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-900 leading-tight">
              虫虫动漫 - 你的免费漫画在线阅读乐园
            </h1>

            <p className="mt-3 text-lg md:text-xl text-primary-500 font-heading">
              随时随地，下拉即读，畅享海量免费漫画
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none">
              虫虫动漫致力于打造最全面的免费漫画与免费看漫画在线平台，收录海量免费动漫全集，覆盖热血、恋爱、悬疑、异世界等全品类题材。
              采用下拉式滚动浏览方式，无需翻页点击即可沉浸式畅读。每日同步更新日本连载与国漫最新话，让每一位漫画爱好者都能在这里找到属于自己的阅读节奏。
              当前热推《鬼灭之刃》《咒术回战》《海贼王》等超人气作品，更有数千部小众精品等您来发掘。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-bold text-foreground-900">10万+</span>
                <span className="text-xs text-foreground-500">漫画资源</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-bold text-foreground-900">每日1000+</span>
                <span className="text-xs text-foreground-500">话更新</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-2xl font-bold text-foreground-900">500万+</span>
                <span className="text-xs text-foreground-500">活跃读者</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <button
                onClick={() => scrollTo('#cards')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                <span>开始阅读</span>
              </button>
              <button
                onClick={() => scrollTo('#index')}
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                <span>浏览分类</span>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20manga%20reading%20scene%2C%20a%20person%20sitting%20on%20a%20comfortable%20couch%20reading%20a%20colorful%20comic%20book%20on%20a%20tablet%20device%2C%20floating%20manga%20panels%20and%20speech%20bubbles%20with%20Japanese%20text%20surrounding%20the%20scene%2C%20warm%20ambient%20lighting%20from%20a%20nearby%20lamp%2C%20bookshelf%20background%20with%20manga%20volumes%2C%20soft%20pastel%20color%20palette%20with%20coral%20and%20cream%20tones%2C%20illustrative%20flat%20design%20style%2C%20highly%20detailed%20and%20charming%20atmosphere&width=800&height=1000&seq=hero-comic-01&orientation=portrait"
                alt="在虫虫动漫平台上舒适阅读漫画的场景"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}